// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3Ter0","inputWrap":"styles_inputWrap__s2_67","input":"styles_input__Qw-lF"};